module.exports = __webpack_public_path__ + "static/media/rainy-4.c8cdb216.svg";